import { Box } from "@mui/material";
import { ErrorCross, PendingText, SuccessCheckmark } from "components/IconsTextsUtils";
import { LinearProgressWithLabel } from "components/LinearProgressWithLabel";
import { AdornmentLoading } from "components/Loading";
import { UploadStatus } from "features/shared/model/types";

type StatusIndicatorProps = {
  className?: string;
  mode: "linear" | "spinner";
  step: {
    percentage?: number;
    status: UploadStatus;
  };
};

export const StatusIndicator = ({ className, mode, step }: StatusIndicatorProps) => {
  if (step.status === "completed") {
    return <SuccessCheckmark className={className} />;
  }
  if (step.status === "error") {
    return <ErrorCross className={className} />;
  }
  if (mode === "linear") {
    const value = Math.min(100, Math.max(0, step.percentage ?? 0));
    return (
      <Box className="min-w-0 flex-1">
        <LinearProgressWithLabel fullWidth value={value} />
      </Box>
    );
  }
  if (step.status === "progress") {
    return <AdornmentLoading className={className} />;
  }
  return <PendingText />;
};
